import OwnableTheme from '@Theme';
import { utilStyles } from '@Utils/utilStyles';
import { MaterialIcons } from '@expo/vector-icons';
import { observer } from 'mobx-react-lite';
import { StyleSheet, View } from 'react-native';

import { useMiniShopFloorPresenter } from './MiniShopFloorPresenter';

export const MiniShopFloorContent = observer(function MiniShopFloorContent() {
  const { departmentsVM, activeDepartmentId } = useMiniShopFloorPresenter();

  return (
    <View style={[utilStyles.height100pc, utilStyles.width100pc]}>
      {departmentsVM.map((item) => (
        <View key={item.id} style={[styles.department, item.ui]}>
          {activeDepartmentId === String(item.id) && (
            <ShopFloorLocationMarker />
          )}
        </View>
      ))}
    </View>
  );
});

const styles = StyleSheet.create({
  department: {
    position: 'absolute',
    backgroundColor: OwnableTheme.colors.lightGray,
    borderRadius: 5,
  },
  marker: {
    justifyContent: 'center',
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
  },
});

const ShopFloorLocationMarker = () => (
  <MaterialIcons
    name='location-pin'
    color='red'
    size={13}
    style={styles.marker}
  />
);
